// extracted by mini-css-extract-plugin
module.exports = {"project":"Project_project__F8o-T","project__body":"Project_project__body__2vfMk"};